import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, FilterDropdown, StatusComponent } from "../../../common/component/Index";
import Amenity from './../../../../../models/Amenity';
import { withTranslation } from "react-i18next";
import { Icon, Menu } from 'antd';
import { PATHS, TRANSLATE_LANGUAGE } from '../../../../../constants/Define';
import moment from "moment";
import Dropdown from '../../../common/component/Dropdown';
import Modal from '../../../common/component/Modal';
import { FlagIcons } from '../../../common/component/TranslateButton';
import { toArray } from 'lodash'
import EllipsisText from '../../../common/component/EllipsisText';

const ListCols = ['code', 'name', 'description', 'isActive', 'translations'];
const ModelFields = Object.getOwnPropertyNames(new Amenity());

class AmenityList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                isActive: {
                    width: 100,
                    key: 'active',
                    render: (isActive) => (
                        <StatusComponent color={isActive ? 'green' : 'red'}
                            label={isActive ? this.props.t('item.amenity.active') : this.props.t('item.amenity.deactive')} />
                    )
                },
                translations: {
                    key: 'languageCode',
                    filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                        value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                    })),
                    filterMultiple: false,
                    width: 120,
                    render: (text, record) => <FlagIcons languages={record.translations} />,
                },
                action: {
                    width: 100,
                    align: 'right',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
        };
    }

    render() {
        const { loading, pagination, amenities } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <ListComponent
                tableKey="amenities-list"
                classChildren="p-0" classParent="m-0"
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(amenities || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'amenity'
                })}
                onChange={this.props.onChange}
                componentTableList={{}}
                onColumnVisibleChange={this.onColumnVisibleChange}
            />
        );
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeAmenity = () => {
            return this.props.onDelete && this.props.onDelete(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.amenity.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeAmenity,
            });
        };
        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.AMENITY.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }
                        {
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }

    getTableColumns() {
        return Func.getTitleTable(['name', 'key', 'value', 'createdDate', 'translations'], ['action'], []);
    }

    componentDidMount(){
        // getColumnVisibleConfigs(ListKeyString, this.state.componentTable);
    }

    onColumnVisibleChange = (column, isVisibled) => {
        const { componentTable } = this.state;
        componentTable[column.dataIndex].visible = isVisibled;
        // setColumnVisibleConfigs(ListKeyString, componentTable);
        this.setState({ componentTable })
    }


}

export default withTranslation()(AmenityList);
